import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { PAGE_CONFIG } from './pageConfig';

const reqParams = '/forecast';

const Forecast = () => (
  <div className='dbd-benchmark-gtdrAssessment-CommonHeader'>
    <CommonPageRender
      reqParams={reqParams}
      pageConfigInit={PAGE_CONFIG}
      renderPageContainer={false}
    />
  </div>
);

export default Forecast;

